import { z } from "zod";

export const LoanPaymentEnum = {
  COLLATERAL_INCREASE: "COLLATERAL_INCREASE",
  INSTALLMENT_PAYMENT: "INSTALLMENT_PAYMENT",
  COLLATERAL: "COLLATERAL",
} as const;

export const loanPaymentSchema = z.enum([
  LoanPaymentEnum.COLLATERAL_INCREASE,
  LoanPaymentEnum.INSTALLMENT_PAYMENT,
  LoanPaymentEnum.COLLATERAL,
]);

export type LoanPaymentType = z.infer<typeof loanPaymentSchema>;